<template>
    <div :id="idwrapper" ref="ext_script" class="ext-script-container">
        <slot></slot>
    </div>
</template>

<script>
import postscribe from 'postscribe';

export default {
    props: {
        src: {
            type: String,
        },
        id: {
            type: String,
            required: false,
            default: 'jotform'
        },
    },
    computed: {
        idwrapper() {
            return this.id + '-wrapper';
        }
    },
    created() {
    },
    mounted() {
        window.postscribe = postscribe;
    
        window.postscribe(this.$el, '<script type="text/javascript" id="'+this.id+'" src="'+this.src+'" ><\/script>', {
            done: () => {
                // console.log('Postsrcibe done for Jotform');
            },
            error: (e) => {
                console.log('Postscribe Errors: ', e);
                this.reloadScript();
            }
        });
    },
    methods: {
        reloadScript() {
            window.postscribe2 = postscribe;
            window.postscribe2(this.$el, '<script type="text/javascript" id="'+this.id+'" src="'+this.src+'" ><\/script>', {
                done: () => {
                    // console.log('Postsrcibe done for Jotform');
                },
                error: (e) => {
                    console.log('Postscribe Errors: ', e);
                }
            });
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/app/components/aha-external-script.vue